import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A stone wishing well — round wall, two posts, a peaked roof and a bucket.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/well.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ box, cone, cylinder, seed }) => {
    const stone = shade(0x8c8881, (rand(seed) - 0.5) * 0.1);
    cylinder(0, 0, 0, 0.95, 1.0, 0.9, stone);              // well wall
    cylinder(0, 0.9, 0, 0.92, 0.92, 0.06, 0x1c2b33);       // dark water/opening
    // two support posts
    box(-0.8, 1.6, 0, 0.16, 1.6, 0.16, 0x6b4a2b);
    box(0.8, 1.6, 0, 0.16, 1.6, 0.16, 0x6b4a2b);
    // crossbar + bucket
    box(0, 2.3, 0, 1.9, 0.16, 0.16, 0x6b4a2b);
    box(0, 1.7, 0, 0.3, 0.3, 0.3, 0x5a3d22);
    // peaked roof
    box(0, 2.45, 0, 2.2, 0.12, 1.4, 0x6e3b2a);
    cone(0, 2.5, 0, 1.5, 0.8, 0x5a2f22);
  };

export default build;
